import { render, staticRenderFns } from "./WizardSteps.vue?vue&type=template&id=0539eb22&"
import script from "./WizardSteps.vue?vue&type=script&lang=js&"
export * from "./WizardSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports